import { Verified } from 'lucide-react'

import { Button } from '@/components/button/button'

import type { ResCreateCases } from '@/lib/queries/business/v1/case/types'
import { cn } from '@/lib/utils'

export interface ConfirmProps {
  nInvalidRows: number
  result: ResCreateCases | null
  submitting: boolean
  onSubmit: () => void
}

export const ImportConfirm: React.FC<ConfirmProps> = ({ nInvalidRows, result, submitting, onSubmit }) => {
  return (
    <div>
      {nInvalidRows > 0 && (
        <div className="mb-8 space-y-1 text-sm">
          <div className="text-red-500">
            Your file has {nInvalidRows} invalid rows. If you continue, these rows will be ignored. Do you want to
            proceed with the import?
          </div>
          <div className="text-muted-foreground">
            *If you prefer to correct the invalid rows, delete the selected file, update the file, and try uploading
            again.
          </div>
        </div>
      )}

      <div className="mb-8 flex justify-center">
        <Button
          className={cn(submitting && 'bg-blue-50 !opacity-100')}
          disabled={submitting || !!result}
          onClick={onSubmit}
        >
          <div className="flex items-center gap-2">
            {submitting ? <Spinner /> : <Verified size={16} />}
            {submitting ? <span className="text-foreground">Uploading...</span> : 'Confirm your file'}
          </div>
        </Button>
      </div>
    </div>
  )
}

const Spinner = () => {
  return (
    <div
      className="border-cobalt-500 text-surface inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-blue-500 border-e-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white"
      role="status"
    >
      <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
        Loading...
      </span>
    </div>
  )
}
